// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { WebAppCandidateVerdictSchema } from '../inputTypeSchemas/WebAppCandidateVerdictSchema'

/////////////////////////////////////////
// EXTERNAL NETWORK WEB APP CLUSTER SCHEMA
/////////////////////////////////////////

export const ExternalNetworkWebAppClusterSchema = z.object({
  verdict: WebAppCandidateVerdictSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  surfaceId: z.string(),
  similarityKey: z.string(),
  canonicalOriginUrl: z.string(),
  apexDomain: z.string(),
  pageTitle: z.string().nullable(),
  faviconHash: z.string().nullable(),
  product: z.string().nullable(),
  applicationId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ExternalNetworkWebAppCluster = z.infer<typeof ExternalNetworkWebAppClusterSchema>

export default ExternalNetworkWebAppClusterSchema;
